import { getAuthIcon } from 'global/auth/authPermissions';
import { gEnums } from 'global/enums/globalEnums';
import { appOptions_left } from 'global/optionLists/appOptionsLeft';
import { useContext, useMemo } from 'react';
import { DemoContext } from '../DemoContext';
import { FrameworkContext } from '../FrameworkContent';
import { GoogleSheetsContext } from '../GoogleSheetsContext';
import { ParentContext } from '../ParentContext';
import { useAppUserAccess } from './useAppUserAccess';

export const useOptionsLeft = ({ leftMenu_handlers }) => {

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { serviceWorker_state, currentSettings_state, app_state, appSettings_state, appUsersAuth_state, appUser_state, paps_state, page_state, manifest_state, eventInfo_state } = states
  const { appUser_fns } = fns
  const { isClone } = appUser_state ?? {}
  const { appUserAuthList } = appUsersAuth_state ?? {}
  const appUserAccess = useAppUserAccess()
  const { accessLevel: appUserAccessLevel, appUserAccessType } = appUserAccess ?? {}
  const currentIcon = getAuthIcon(appUserAccessLevel)
  const authSettingsPermissionType = appUser_fns.validate_trueSettingsAuth(appUserAccess)
  const _viewPermissionType_settings = appUser_fns.validate_settingsAuth(appUserAccess, true)

  let allowAdmin = authSettingsPermissionType === gEnums.viewPermissionTypes.allow
  let allowSideSettings = _viewPermissionType_settings === gEnums.viewPermissionTypes.allow

  switch (appUserAccessType) {
    // this are ME
    case gEnums.appUserAccessTypes.admin:
    case gEnums.appUserAccessTypes.superAdmin:
      // allowAdmin = gEnums.viewPermissionTypes.deny
      // allowSideSettings = gEnums.viewPermissionTypes.deny
      break;

    // if a appAdmin or appProfile, validate the path
    case gEnums.appUserAccessTypes.appDataAdmin:
    case gEnums.appUserAccessTypes.appDataAdminLimited:
    case gEnums.appUserAccessTypes.appAdmin:
    case gEnums.appUserAccessTypes.appSubAdmin:
      break;

    default:
      allowAdmin = gEnums.viewPermissionTypes.deny
  }

  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { settingsSourceType, settingsOriginalSourceType, _appSettingsOriginType } = _.get(page_state, 'pageSettings', {});
  const { tempDataSource, authOn, helpOn, appConfigSettings, currentAppDevice, appHistory } = appSettings_state ?? {}
  const { appArea, pathViews, pathModes } = paps_state ?? {}
  const { startIcon } = manifest_state ?? {}
  const { appDataSource, googleSheets } = aps_global ?? {}
  const { appDataSourceType, allowAppDataDocumentsUpdate } = appDataSource ?? {}
  const { allowGoogleSheets, googleSheetsId } = googleSheets ?? {}
  const { appNames, isMeProd } = appConfigSettings ?? {}
  const { appName, appEnv, isLocal } = appNames ?? {}
  const { appComponents } = aps_global ?? {}
  const { componentContent } = appComponents ?? {}

  const { appUsersPresense } = eventInfo_state ?? {}
  const { online, offline } = appUsersPresense ?? {}

  const { isSuperAdmin: _isSuperAdmin, isSuperAdminDeveloper: _isSuperAdminDeveloper } = appUserAccess ?? {}
  const isClient = pathViews.clients
  const isEvent = pathViews.events

  // frameworkContext
  const frameworkContext = useContext(FrameworkContext);
  const { framework_state } = frameworkContext ?? {}
  const { showLeftMenuCaptions, permissionGroups } = framework_state ?? {}

  // serviceWorkerContext 
  const { deferredPrompt, registration, registrationSuccess } = serviceWorker_state ?? {}

  // demoContext
  const demoContext = useContext(DemoContext)
  const { demo_state } = demoContext ?? {}
  const { demoOn } = demo_state ?? {}

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_state } = googleSheetsContext ?? {}
  const { updating } = googleSheets_state ?? {}

  const _appDataSourceType = tempDataSource ? tempDataSource : appDataSourceType

  // appSettingsContext 
  const {
    altDatabaseOn,
    dataOverrideOn,
    demoOverrideOn,
    prodOverrideOn,
    settingsPreviewOn,
  } = appSettings_state ?? {}


  const allowSd = pathModes.sport || pathModes.district || pathModes.organization

  let dashboardType;

  if (pathModes.sport) {
    dashboardType = 'Sports'
  } else if (pathModes.district) {
    dashboardType = 'District'
  } else if (pathModes.organization) {
    dashboardType = 'Organization'
  }

  let allowGf = false

  switch (componentContent) {
    case gEnums.componentContentTypes.golfEvent:
      allowGf = true
      dashboardType = 'Golf'
      break;
    default:
    // nothing
  }

  const _settings = {
    _appDataSourceType,
    _appSettingsOriginType,
    _isSuperAdmin,
    _isSuperAdminDeveloper,
    allowAdmin,
    allowAppDataDocumentsUpdate,
    allowGf,
    allowGoogleSheets,
    allowSd,
    allowSideSettings,
    altDatabaseOn,
    app_state,
    appArea,
    appDataSource,
    appEnv,
    appHistory,
    appName,
    appUserAccess,
    appUserAuthList,
    appUsersPresense,
    aps_global,
    authOn,
    currentAppDevice,
    currentIcon,
    dashboardType,
    dataOverrideOn,
    deferredPrompt,
    demoOn,
    demoOverrideOn,
    fn_cls,
    googleSheetsId,
    helpOn,
    isClient,
    isClone,
    isEvent,
    isLocal,
    isMeProd,
    offline,
    online,
    pathViews,
    pathViews,
    permissionGroups,
    prodOverrideOn,
    registration,
    registrationSuccess,
    settingsOriginalSourceType,
    settingsPreviewOn,
    settingsSourceType,
    showLeftMenuCaptions,
    startIcon,
    updating,
  }

  const leftOptions = useMemo(() => {

    const { allowAdmin, allowSideSettings } = _settings

    if (allowSideSettings) {
      const _leftOptions = {}
      _.forEach(appOptions_left, (alo, key) => {
        _leftOptions[key] = alo(leftMenu_handlers, _settings)
      })
      return _leftOptions
    } else {
      const _leftOptions = {
        device: appOptions_left.device(leftMenu_handlers),
        devices: appOptions_left.devices(leftMenu_handlers),
      }
      if (allowAdmin === gEnums.viewPermissionTypes.allow) {
        _leftOptions.appUser = appOptions_left.appUser(leftMenu_handlers, _settings)
        _leftOptions.appUsers = appOptions_left.appUsers(leftMenu_handlers)
      }
      return _leftOptions
    }

  }, [_settings])

  return leftOptions
}
